import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileService } from '../services/file.service';

@Pipe({
  name: 'safeBaseUrl'
})
export class SafeBaseUrlPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer,
    private fileService: FileService) { }

  transform(unsafeContent: any, mimeType: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.fileService.createBlobUrlFromBaseString(unsafeContent, mimeType));
  }

}
